module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-builder-editor-field', _vm._g({
    attrs: {
      "item": _vm.item,
      "show-required": true,
      "show-hide-in-form": true,
      "show-hide-in-reports": true,
      "show-hide-in-preview": true,
      "show-share-with-participant": true,
      "show-is-shared": true
    }
  }, _vm.$listeners), [_c('template', {
    slot: "header"
  }, [_c('editor-checkbox', {
    attrs: {
      "label": "Multiple",
      "id": _vm.item.name + '_multiple'
    },
    model: {
      value: (_vm.item.multiple),
      callback: function($$v) {
        _vm.$set(_vm.item, "multiple", $$v)
      },
      expression: "item.multiple"
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66d78bc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/FormBuilderEditorFile.vue
// module id = 1677
// module chunks = 1